module.exports = __webpack_public_path__ + "img/bluetube.f1b06ef7.png";